import type { ModelSpec, ProviderModels } from "../types";
import { THINKING_LEVELS, type ThinkingLevel } from "../../../shared/wire/sessions.ts";

/** Every thinking level, in the order the picker lists them. */
export { THINKING_LEVELS };

/** A level as pi reports it, read as one a pin can carry; anything else reads as the default. */
export function thinkingLevelOf(level: string | undefined): ThinkingLevel {
	return THINKING_LEVELS.find((l) => l === level) ?? "medium";
}

/**
 * The pin to send when the provider select changes. A provider needs a model to go with it: the
 * one the session is running when it is that provider's, else the first in its catalog. The empty
 * entry (the profile's model), and a provider the catalog no longer lists, unpin.
 */
export function providerChoice(provider: string, catalog: ProviderModels[], running: ModelSpec, thinking: ThinkingLevel): ModelSpec | null {
	if (!provider) return null;
	const entry = catalog.find((p) => p.provider === provider);
	if (!entry || entry.models.length === 0) return null;
	const name = provider === running.provider && entry.models.some((m) => m.id === running.name) ? running.name : entry.models[0]!.id;
	return { provider, name, thinking };
}

/** The pin to send when only the thinking level changes: the model stays what is running, now pinned. */
export function thinkingChoice(current: ModelSpec | null, running: ModelSpec, thinking: ThinkingLevel): ModelSpec {
	return { ...(current ?? running), thinking };
}
